import type { RouterContext } from '@atlassian/react-resource-router';
import { combineFilterJqlWithSearchText } from './text-search.tsx';

export type BoardQuerySettings = {
	filterJql?: string;
	groupBy?: string;
};

export const getBoardQueryParams = (routerContext?: RouterContext): BoardQuerySettings => {
	let filter: string | undefined;
	let text: string | undefined;
	let groupBy: string | undefined;

	// if in a client environment, check whether the router url matches the current window pathname
	// if it does, use the filter and groupBy from the current window location instead of the router query
	// this avoids reloading the query without the overrides when a user hovers over prefetching links that don't include them
	const currentLocation = typeof window !== 'undefined' ? window.location : null;

	if (
		currentLocation != null &&
		(routerContext == null || currentLocation.pathname === routerContext?.match.url)
	) {
		const urlSearchParams = new URLSearchParams(currentLocation.search);
		filter = urlSearchParams.get('filter') ?? undefined;
		text = urlSearchParams.get('text') ?? undefined;
		groupBy = urlSearchParams.get('groupBy') ?? undefined;
	} else if (routerContext) {
		filter = routerContext.query?.filter;
		text = routerContext.query?.text;
		groupBy = routerContext.query?.groupBy;
	}

	const filterJql = combineFilterJqlWithSearchText(filter, text);

	return {
		filterJql,
		groupBy,
	};
};
